export default "__VITE_ASSET__BMpYAhqK__"